module.exports = __webpack_public_path__ + "img/loading.124fd51b.gif";